export default __webpack_public_path__ + "static/media/products_523.d14ec0d6.jpg";